import { SelectInputData } from 'src/app/shared/interfaces/select-input-data.interface';
import { SortOrder } from 'src/app/shared/models/sort-criteria';
import { ConnectionStatus } from 'src/lib/fliko/models/connection/connection.data';
import { ResidentConnectionVM } from 'src/app/view/connections/services/models/connections.view-model';

export type ConnectionNotesFilter = 'all' | 'with-notes' | 'without-notes';
export type ConnectionTimeFilter = 'all' | '00-06' | '06-12' | '12-18' | '18-24';
export type ConnectionDisplayStatus = ResidentConnectionVM['status'];
export type ConnectionTone = 'positive' | 'negative' | 'ongoing';

export interface ConnectionFilters {
  sort: SortOrder;
  resident: string;
  adminPhone: string;
  direction: ResidentConnectionVM['direction'] | 'all';
  status: ConnectionDisplayStatus | 'all';
  date: string;
  time: ConnectionTimeFilter;
  notes: ConnectionNotesFilter;
}

export type ConnectionFilterKey = Exclude<keyof ConnectionFilters, 'sort'>;
export type ConnectionFilterValue = ConnectionFilters[keyof ConnectionFilters];

export interface ConnectionFilterBadge {
  key: keyof ConnectionFilters;
  label: string;
  title: string;
  removable: boolean;
}

export interface ConnectionFilterOptions {
  sort: SelectInputData<SortOrder>[];
  resident: SelectInputData<string>[];
  adminPhone: SelectInputData<string>[];
  direction: SelectInputData<ResidentConnectionVM['direction'] | 'all'>[];
  status: SelectInputData<ConnectionDisplayStatus | 'all'>[];
  date: SelectInputData<string>[];
  time: SelectInputData<ConnectionTimeFilter>[];
  notes: SelectInputData<ConnectionNotesFilter>[];
}

export const CONNECTION_FILTER_KEYS: ConnectionFilterKey[] = [
  'resident',
  'adminPhone',
  'direction',
  'status',
  'date',
  'time',
  'notes'
];

export function getDefaultConnectionFilters(): ConnectionFilters {
  return {
    sort: SortOrder.DSC,
    resident: 'all',
    adminPhone: 'all',
    direction: 'all',
    status: 'all',
    date: 'all',
    time: 'all',
    notes: 'all'
  };
}

export function getEmptyConnectionFilterOptions(): ConnectionFilterOptions {
  return {
    sort: [],
    resident: [],
    adminPhone: [],
    direction: [],
    status: [],
    date: [],
    time: [],
    notes: []
  };
}

export function getConnectionDisplayStatus(connection: ResidentConnectionVM): ConnectionDisplayStatus {
  return connection.isOngoing ? ConnectionStatus.ONGOING : connection.status;
}

export function getConnectionTone(connection: ResidentConnectionVM): ConnectionTone {
  if (connection.isOngoing) return 'ongoing';

  return connection.status === ConnectionStatus.ANSWERED ? 'positive' : 'negative';
}

export function isUnassignedResidentConnection(connection: ResidentConnectionVM): boolean {
  return !connection.residentId;
}
